import { useState, useRef, useEffect } from 'react';

const DAYS=['Su','Mo','Tu','We','Th','Fr','Sa'];

function fmt(d){return d.toISOString().split('T')[0];}
function parse(s){const[y,m,d]=s.split('-').map(Number);return new Date(y,m-1,d);}
function sameDay(a,b){return a.getFullYear()===b.getFullYear()&&a.getMonth()===b.getMonth()&&a.getDate()===b.getDate();}
function between(d,a,b){return d>=a&&d<=b;}
function monthLabel(year,month){return new Date(year,month).toLocaleDateString('en-US',{month:'long',year:'numeric'});}

export default function DateRangePicker({start,end,onChange,t,si}){
const[open,setOpen]=useState(false);
const[picking,setPicking]=useState(null); // null | {start: Date}
const[hover,setHover]=useState(null);
const ref=useRef(null);

// Calendar view month — start from the start date or today
const initMonth=start?parse(start):new Date();
const[viewYear,setViewYear]=useState(initMonth.getFullYear());
const[viewMonth,setViewMonth]=useState(initMonth.getMonth());

useEffect(()=>{
  if(!open)return;
  function onClick(e){if(ref.current&&!ref.current.contains(e.target)){setOpen(false);setPicking(null);setHover(null);}}
  document.addEventListener('mousedown',onClick);
  return()=>document.removeEventListener('mousedown',onClick);
},[open]);

function prevMonth(){if(viewMonth===0){setViewYear(y=>y-1);setViewMonth(11);}else setViewMonth(m=>m-1);}
function nextMonth(){if(viewMonth===11){setViewYear(y=>y+1);setViewMonth(0);}else setViewMonth(m=>m+1);}

function handleDayClick(day){
  if(!picking){
    // First click — set start, wait for end
    setPicking({start:day});
    setHover(null);
  }else{
    // Second click — set end and close
    let s=picking.start,e=day;
    if(e<s){const tmp=s;s=e;e=tmp;}
    onChange(fmt(s),fmt(e));
    setPicking(null);
    setHover(null);
    setOpen(false);
  }
}

// Build calendar grid
const firstOfMonth=new Date(viewYear,viewMonth,1);
const startDay=firstOfMonth.getDay();
const daysInMonth=new Date(viewYear,viewMonth+1,0).getDate();
const cells=[];
for(let i=0;i<startDay;i++)cells.push(null);
for(let d=1;d<=daysInMonth;d++)cells.push(new Date(viewYear,viewMonth,d));

// Range for highlighting
const rangeStart=picking?picking.start:(start?parse(start):null);
const rangeEnd=picking?(hover||picking.start):(end?parse(end):null);
const lo=rangeStart&&rangeEnd&&rangeEnd<rangeStart?rangeEnd:rangeStart;
const hi=rangeStart&&rangeEnd&&rangeEnd<rangeStart?rangeStart:rangeEnd;

const displayStart=start||'';
const displayEnd=end||'';
const label=displayStart&&displayEnd
  ?`${parse(displayStart).toLocaleDateString('en-US',{month:'short',day:'numeric'})} — ${parse(displayEnd).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'})}`
  :displayStart||'Select dates...';

return(
<div ref={ref} style={{position:'relative',display:'inline-block'}}>
<button onClick={()=>{setOpen(p=>!p);setPicking(null);setHover(null);if(!open&&start){const d=parse(start);setViewYear(d.getFullYear());setViewMonth(d.getMonth());}}} style={{...si,padding:'6px 12px',fontSize:11,cursor:'pointer',minWidth:200,textAlign:'left',background:t.sf,border:`1px solid ${open?t.bl:t.bd}`,borderRadius:8,color:t.tm}}>
{label}
</button>

{open&&<div style={{position:'absolute',top:'100%',left:0,zIndex:30,marginTop:4,background:t.bg,border:`2px solid ${t.bl}`,borderRadius:12,padding:12,boxShadow:'0 12px 32px rgba(0,0,0,0.3)',width:280}}>
{/* Month nav */}
<div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
<button onClick={prevMonth} style={{background:'none',border:'none',color:t.tm,cursor:'pointer',fontSize:16,padding:'4px 8px'}}>‹</button>
<span style={{fontSize:13,fontWeight:600,color:t.tx}}>{monthLabel(viewYear,viewMonth)}</span>
<button onClick={nextMonth} style={{background:'none',border:'none',color:t.tm,cursor:'pointer',fontSize:16,padding:'4px 8px'}}>›</button>
</div>

{/* Instruction */}
<div style={{fontSize:9,color:t.td,textAlign:'center',marginBottom:6}}>
{picking?'Click end date':'Click start date'}
</div>

{/* Day headers */}
<div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',gap:1,marginBottom:2}}>
{DAYS.map(d=><div key={d} style={{textAlign:'center',fontSize:9,color:t.td,fontWeight:600,padding:2}}>{d}</div>)}
</div>

{/* Calendar grid */}
<div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',gap:1}}>
{cells.map((day,i)=>{
  if(!day)return<div key={`e${i}`}/>;
  const isStart=lo&&sameDay(day,lo);
  const isEnd=hi&&sameDay(day,hi);
  const inRange=lo&&hi&&between(day,lo,hi);
  const isToday=sameDay(day,new Date());
  const bg=isStart||isEnd?t.bl:inRange?'rgba(59,130,246,0.15)':'transparent';
  const color=isStart||isEnd?'#fff':isToday?t.bl:t.tx;
  const fontWeight=isToday||isStart||isEnd?700:400;
  const borderRadius=isStart?'8px 0 0 8px':isEnd?'0 8px 8px 0':inRange?0:8;
  return<div key={i}
    onClick={()=>handleDayClick(day)}
    onMouseEnter={()=>{if(picking)setHover(day);}}
    style={{textAlign:'center',padding:'6px 0',fontSize:11,cursor:'pointer',background:bg,color,fontWeight,borderRadius,transition:'background 0.1s'}}
  >{day.getDate()}</div>;
})}
</div>
</div>}
</div>);
}
